"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function VmwareVmsblueMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__vmware-vmsblue-multitone-filled__clip0_13467_69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CAF0FC",
    fillRule: "evenodd",
    d: "M13.06.38H7.652a2.568 2.568 0 00-2.56 2.56v2.156H2.936A2.566 2.566 0 00.38 7.652v5.408a2.567 2.567 0 002.556 2.56h5.416c1.4 0 2.552-1.152 2.552-2.56v-2.156h2.156a2.568 2.568 0 002.56-2.56V2.94A2.568 2.568 0 0013.06.38z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M8.352 16H2.936A2.941 2.941 0 010 13.06V7.652a2.938 2.938 0 012.936-2.936h1.772V2.94c0-1.62 1.32-2.94 2.94-2.94h5.408A2.946 2.946 0 0116 2.94v5.404c0 1.62-1.32 2.94-2.94 2.94h-1.772v1.772A2.945 2.945 0 018.352 16zM2.936 5.476c-1.2 0-2.176.976-2.176 2.176v5.408c0 1.2.976 2.18 2.176 2.18h5.416a2.178 2.178 0 002.172-2.18v-2.156a.38.38 0 01.38-.38h2.156c1.2 0 2.18-.976 2.18-2.18V2.94c0-1.2-.976-2.18-2.18-2.18H7.652c-1.2 0-2.18.976-2.18 2.18v2.156a.38.38 0 01-.38.38H2.936z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M12.356 2.908h-4.12a.742.742 0 00-.744.74v4.116c0 .044.004.092.016.132.052.3.288.54.588.592a.507.507 0 00.136.016h4.12a.74.74 0 00.736-.744V3.648a.73.73 0 00-.732-.74zm-.068 4.796H8.296V3.712h3.992v3.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M8.488 8.104a.727.727 0 00-.592-.592.497.497 0 00-.132-.016H3.648a.738.738 0 00-.74.74v4.124c0 .404.328.736.74.736h4.116a.74.74 0 00.74-.736V8.232c-.004-.044-.008-.088-.016-.128zm-4.776.192H7.7v3.992H3.712V8.296z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__vmware-vmsblue-multitone-filled__clip0_13467_69"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

VmwareVmsblueMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
VmwareVmsblueMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = VmwareVmsblueMultitoneFilled;
exports["default"] = _default;